module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Bettens_(Vaud)-89e4b8ea972cb66dee44116de479c546.svg";